export const clearField = (
  formThis,
  {field, keepTouched = false, persistentSubmitErrors = false}
) => formThis.props.clearFields(keepTouched, persistentSubmitErrors, field);
